import { AxiosResponse } from 'axios';
import get from 'lodash/get';

import { AJSResponse } from '@qality/common-model/src/AP/AJS';
import { APResponse } from '@qality/common-model/src/AP/AP';

export default {
  async retry(
    fn: () => Promise<AxiosResponse | APResponse | AJSResponse>,
    retriesLeft = 3,
    interval = 1000
  ): Promise<AxiosResponse | APResponse | AJSResponse> {
    try {
      const val = await fn();
      return val;
    } catch (error) {
      const status = get(error, 'xhr.status');
      if (status === 401 || status === 403 || status === 404) {
        throw error;
      }

      if (retriesLeft) {
        // eslint-disable-next-line promise/avoid-new
        await new Promise((resolve) => setTimeout(resolve, interval));
        return this.retry(fn, retriesLeft - 1, interval);
      } else {
        throw error;
      }
    }
  },
};
